const Service = require('gui/inputs/service');

module.exports = class RadioService extends Service {
  constructor(opts = {}) {
    super(opts);
  }
};
